import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LayoutSite } from "./components/layout";
import { CalendarPage } from "./pages/calendar";
import { WeekPage } from "./pages/week";
import { ImportFRPage } from "./pages/importfr";
import { ImportUSPage } from "./pages/importus";
import { LoginPage } from "./pages/login";
import { RacePage } from "./pages/race";
import { AuthProvider } from './services/auth.service';
import "./app.scss";
import { TracksPage } from "./pages/tracks";
import { EditTrackPage } from "./pages/edittrack";
import { ImportQAPage } from "./pages/importqa";
import { EventsGNETPage } from "./pages/eventsgnet";
import { ImportVenuesPage } from "./pages/importvenues";
import { ImportTracksPage } from "./pages/importtracks";
import { EventsPage } from "./pages/events";
import { ImuPage } from "./pages/imu";
import { SettingsPage } from "./pages/settings";
import { NewRacePage } from "./pages/newrace";
import { hasOnlyImu, isViewer } from "./services/auth.header";

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    const withOnlyIMU = hasOnlyImu();
    const viewer = isViewer();

    return (
        <BrowserRouter basename="/">
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={withOnlyIMU ? <ImuPage /> : <CalendarPage />} />
                        <Route path="/calendar" element={<CalendarPage />} />
                        <Route path="/week" element={<WeekPage />} />
                        <Route path="/race/:date/:track/:raceno" element={<RacePage />} />
                        {
                            // viewer: calendar / week / race only
                            !viewer &&
                            <>
                                <Route path="/import" element={<ImportFRPage />} />
                                <Route path="/importus" element={<ImportUSPage />} />
                                <Route path="/importqa" element={<ImportQAPage />} />
                                <Route path="/eventsgnet" element={<EventsGNETPage />} />
                                <Route path="/events" element={<EventsPage />} />
                                <Route path="/imu" element={<ImuPage />} />
                                <Route path="/tracks" element={<TracksPage />} />
                                <Route path="/edittrack" element={<EditTrackPage />} />
                                <Route path="/importvenues" element={<ImportVenuesPage />} />
                                <Route path="/importtracks" element={<ImportTracksPage />} />
                                <Route path="/settings" element={<SettingsPage />} />
                                <Route path="/newrace" element={<NewRacePage />} />
                            </>
                        }
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="*" element={<LayoutSite><p>Wrong page</p></LayoutSite>} />
                    </Routes>
                </AuthProvider>
        </BrowserRouter>
    );
}
